
<table [hidden]="print==1">
    <tr style="text-align: center;">
      <th colspan="3">İŞLETME ADI</th>
      <th colspan="9">İŞLETME TEL</th>
      <th colspan="9">İŞLETME E-POSTA</th>
      <th colspan="9">AİT OLDUĞU AY</th>
      <th colspan="10">DÜZENLEME TARİHİ</th>
    </tr>
    <tr style="text-align: center;">
      <td colspan="3">{{yaz_isyeri_adi}}</td>
      <td colspan="9">{{yaz_isyeri_tel}}</td>
      <td colspan="9">{{eposta}}</td>
      <td colspan="9">{{ayadi}}</td>
      <td colspan="10">{{duzen_tarih}}</td>
    </tr>
    <tr>
      <th style="text-align: center;" colspan="3">ÖĞRENCİNİN</th>
      <th style="text-align: center;" colspan="32">GÜNLER</th>
      <th style="text-align: center;" colspan="2">TOPLAM<br>DEVAMSIZLIK</th>
    </tr>
    <tr style="text-align: center; width:14px;">
      <td>ADI SOYADI</td>
      <td>NUMARASI</td>
      <td>ALAN/DAL</td>
      <td></td>
      <td style="text-align: center; width:20px;">1</td>
      <td style="text-align: center; width:20px;">2</td>
      <td style="text-align: center; width:20px;">3</td>
      <td style="text-align: center; width:20px;">4</td>
      <td style="text-align: center; width:20px;">5</td>
      <td style="text-align: center; width:20px;">6</td>
      <td style="text-align: center; width:20px;">7</td>
      <td style="text-align: center; width:20px;">8</td>
      <td style="text-align: center; width:20px;">9</td>
      <td style="text-align: center; width:20px;">10</td>
      <td style="text-align: center; width:20px;">11</td>
      <td style="text-align: center; width:20px;">12</td>
      <td style="text-align: center; width:20px;">13</td>
      <td style="text-align: center; width:20px;">14</td>
      <td style="text-align: center; width:20px;">15</td>
      <td style="text-align: center; width:20px;">16</td>
      <td style="text-align: center; width:20px;">17</td>
      <td style="text-align: center; width:20px;">18</td>
      <td style="text-align: center; width:20px;">19</td>
      <td style="text-align: center; width:20px;">20</td>
      <td style="text-align: center; width:20px;">21</td>
      <td style="text-align: center; width:20px;">22</td>
      <td style="text-align: center; width:20px;">23</td>
      <td style="text-align: center; width:20px;">24</td>
      <td style="text-align: center; width:20px;">25</td>
      <td style="text-align: center; width:20px;">26</td>
      <td style="text-align: center; width:20px;">27</td>
      <td style="text-align: center; width:20px;">28</td>
      <td style="text-align: center; width:20px;">29</td>
      <td style="text-align: center; width:20px;">30</td>
      <td style="text-align: center; width:20px;">31</td>
      <td>ÖZÜRLÜ</td>
      <td>ÖZÜRSÜZ</td>
    </tr>
   <tbody  *ngFor="let item of ogrenciler">
    <tr>
      <td rowspan="2">{{item.ogr_isim}} {{item.ogr_soyisim}}</td>
      <td rowspan="2">{{item.ogr_no}}</td>
      <td rowspan="2"></td>
      <td style="text-align: center;">S</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
    <tr>
      <td style="text-align: center;">Ö</td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
      <td></td>
    </tr>
  </tbody>
    <tr>
      <td style="text-align: center;"  colspan="12">İŞLETME YETKİLİSİ</td>
      <td style="text-align: center;" colspan="12">İNCELENDİ </td>
      <td style="text-align: center;"  colspan="14">Devamın Göstereceği Semboller</td>
    </tr>
    <tr>
      <td style="text-align: center;"  colspan="12">..../..../.... </td>
      <td style="text-align: center;" colspan="12">..../..../.... </td>
      <td style="text-align: center;"  colspan="14">X: İşletmede  O: Okulda</td>
    </tr>
    <tr>
      <td style="text-align: center;"  colspan="12">Adı Soyadı </td>
      <td style="text-align: center;" colspan="12"></td>
      <td style="text-align: center;"  colspan="14">Devamsızlığın Göstereceği Semboller</td>
    </tr>
    <tr>
      <td style="text-align: center;"  colspan="12">Kaşe - İmza </td>
      <td style="text-align: center;" colspan="12">Koordinatör Müdür Yardımcısı</td>
      <td style="text-align: center;"  colspan="14">İ: İzinli  D: Özürsüz Devamsızlık <br> H: Hasta Sevkli  S: Sabah  R: Raporlu <br> Ö: Öğle T: Resmi Tatil</td>
    </tr>
    <tr>
      <td colspan="38"> Bu çizelge, işletme tarafından tutlacak, öğrencinin işletmede bulunması gereken günlere ait devamsızlık durumları ilgili sütunda, yanda gösterilen uygun sembolle belirlenecektir. <br>
      (İ), (H), (R) Sembolleri ile gösterilen devamsızlıklar toplamı özürlü devamsızlık sütüna yazılacaktır.
      </td>
    </tr>
  </table>

  <table [hidden]="print==2" class="table table-sm">
    <tbody>
    <tr>
    <td colspan="2">
    <strong>İş Yerinin</strong>
    </td>
    <td>Meslek Alanı</td>
    <td colspan="6"></td>
    </tr>
    <tr>
    <td  colspan="2" rowspan="2"><b>{{yaz_isyeri_adi}}</b></td>
    <td>Adresi</td>
    <td colspan="6"><b>{{yaz_isyeri_adres}}</b></td>
    </tr>
    <tr>
    <td>Telefon No</td>
    <td><b>{{yaz_isyeri_tel}}</b></td>
    <td colspan="2">Faks No</td>
    <td colspan="3"></td>
    </tr>
    <tr>
    <td colspan="9" class="text-center"><strong>İşverenin / Pratik Eğitimden Sorumlu Usta öğreticinin</strong></td>
    </tr>
    <tr>
    <td>Adı Soyadı</td>
    <td colspan="2"><b>{{yaz_usta_adi}} {{yaz_usta_soyadi}}</b></td>
    <td colspan="3" rowspan="2">İmza ve Kaşesi</td>
    <td colspan="3" rowspan="2"></td>
    </tr>
    <tr>
    <td>Unvanı</td>
    <td colspan="2"><b>Usta öğretici</b></td>
    </tr>
    <tr>
    <td colspan="9" class="text-center" ><strong>Öğrencinin</strong></td>
    </tr>
    <tr>
    <td colspan="2">Adı Soyadı</td>
    <td>Sınıfı</td>
    <td>Okul No</td>
    <td colspan="5">Açıklama</td>
    </tr>
    <tr *ngFor="let ogr of ogrenciler">
    <td colspan="2"><b> {{ogr.ogr_isim}} {{ogr.ogr_soyisim}}</b></td>
    <td><b>{{ogr.sinif}}</b></td>
    <td><b>{{ogr.ogr_no}}</b></td>
    <td colspan="5"></td>
    </tr>

    <tr>
    <td colspan="2" rowspan="2">İş Yerinde Çalışan Çırak Sayısı
    </td>
    <td>Sözleşmeli
    </td>
    <td>Sözleşmesiz
    </td>
    <td colspan="5" rowspan="2"></td>
    </tr>
    <tr>
    <td></td>
    <td></td>
    </tr>
    <tr>
    <td colspan="9" class="text-center"><strong>İş Yeri ve öğrenci Hakkındaki Bilgiler (İlgili Kutuyu İşaretleyin)</strong></td>
    </tr>
    <tr>
    <td colspan="4"><i class="bx bx-square-rounded"></i> öğrenci pratik eğitimini sürdürmektedir</td>
    <td colspan="5"><i class="bx bx-square-rounded"></i> İş yeri adresi değişmiştir</td>
    </tr>
    <tr>
    <td colspan="4"><i class="bx bx-square-rounded"></i> Öğrenci işyerinden ayrılmıştır</td>
    <td colspan="5"><i class="bx bx-square-rounded"></i> İş yeri şu anda kapalıdır</td>
    </tr>
    <tr>
    <td colspan="4"><i class="bx bx-square-rounded"></i> İşveren olmadığı iÇin imza ve görüş alınmadı</td>
    <td colspan="5"><i class="bx bx-square-rounded"></i> Diğer hususlar</td>
    </tr>
    <tr>
    <td colspan="4"><i class="bx bx-square-rounded"></i> Pratik eğitimin konusu ile İş Sağlığı ve Güvenliği (İSG) konularındaki öğretmenin görüş ve gözlemleri:</td>
    <td colspan="5"><i class="bx bx-square-rounded"></i> Usta öğreticinin görüş, gözlem ve önerileri Varsa (Buraya yazınız): Var Yok
    </td>
    </tr>
    <tr>
    <td colspan="4">İş yerinde İşletmedeki Mesleki Eğitim Çalışmalarına</td>
    <td>Başlama Saati</td>
    <td colspan="2"></td>
    <td>Bitiş Saati</td>
    <td></td>
    </tr>
    <tr>
    <td colspan="4" class="text-center" style="border-right:0px solid black;">
       
        <strong> Meslek Dersi (Koordinatör) öğretmeni </strong>
    </td>
    <td colspan="5" class="text-center" style="border-left:0px solid black;">
        <strong>..../..../20..</strong>
        <br><strong>İncelenmiştir</strong>
        <br><strong></strong>
        <br><strong>Koordinatör Müdür Yrd.</strong></td>
    </tr>
    </tbody>
    </table>